<style>
input[type="checkbox"][readonly] {
  pointer-events: none;
}
</style>

<template>
  <div>
	  
	<Header :style="{ backgroundx: '#fff', 'line-height': '50px', height: '50px', 'padding-right': '10px', 'margin-bottom': '5px'}">
		<div :style="{float: 'right'}">
			<Button type="primary" shape="circle" icon="ios-person-add" @click="add">
				Add
			</Button>
			<!-- <Icon type="ios-person-add" size="24"/> -->
			
		</div>
	</Header>
	  
    <!-- <Layout :style="{overflowY: 'scroll', marginTop: '60px'}"> -->
      <Table :styleX="{marginTop: '100px'}" heightx="300" border :columns="columns" :data="items"></Table>
    <!-- </Layout> -->

	
	<Modal v-if="selectedItem" v-model="editProperty" width="360" @on-visible-change="showhidemodal" :closable="true" :mask-closable="true">
		<p slot="header" style="color:#f60;text-align:center">
			<Icon type="ios-information-circle"></Icon>
			<span>{{ addMode ? 'Add User' : 'Edit User' }}</span>
		</p>
		
		<Form v-if="renderForm" ref="form" :model="selectedItem" :rules="ruleValidate" :label-width="120">
			<FormItem label="Username" prop="Username">
				<Input v-model="selectedItem.Username" placeholder="Username" />
			</FormItem>
			<FormItem label="Name" prop="Name">
				<Input v-model="selectedItem.Name" placeholder="Name" />
			</FormItem>
			<FormItem label="Set Password" prop="Password">
				<Input type="password" v-model="selectedItem.Password" placeholder="Password" />
			</FormItem>
			<FormItem label="Reenter Password" prop="Password">
				<Input type="password" v-model="selectedItem.Repassword" placeholder="Reenter Password" />
			</FormItem>
			<FormItem label="Administrator">
				<i-switch v-model="selectedItem.IsAdmin" size="large">
					<span slot="open">Yes</span>
					<span slot="close">No</span>
				</i-switch>
			</FormItem>
		</Form>
			
		<div slot="footer">
			<Button type="text" size="large" longx @click="editProperty = false">Cancel</Button>
			<Button type="primary" size="large" longx @click="save">OK</Button>
		</div>

	</Modal>

	<Modal v-model="confirmDelete" width="360">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="ios-information-circle"></Icon>
            <span>Delete confirmation</span>
        </p>
        <div style="text-align:center">
            <p>This action cannot be undone!</p>
            <p>Are you sure?</p>
        </div>
        <div slot="footer">
            <Button type="error" size="large" long @click="deleteOK">Delete</Button>
        </div>
    </Modal>

  </div>
</template>

<script>
import { stat } from 'fs';
import { setTimeout } from 'timers';

export default {
  methods: {
	
	add () {
	  this.ruleValidate.Password[0].required = true;
	  this.addMode = true;
	  this.selectedItem = {};
	  this.editProperty = true;
	},
	
	edit (index) {
		this.ruleValidate.Password[0].required = false;
	  this.addMode = false;
	  this.selectedIndex = index;
	  this.selectedItem = {};

	  delete this.items[index].Password;
	  delete this.items[index].Repassword;
	  Object.assign(this.selectedItem, this.items[index]);
	  this.editProperty = true;
	},

	save() {
		
		this.$refs.form.validate(result => {
			if (!result) {
				return;
			}

			if (this.selectedItem.Password != this.selectedItem.Repassword) {
				return this.$Modal.error({
					title: 'Error',
					content: 'Password and confirmed Password must match!'
				});
			}
			
			if (this.selectedItem.Password) {
				this.selectedItem.Password = this.selectedItem.Password.hashMD5();
				delete this.selectedItem.Repassword;
			}
			
			if (this.addMode) {

				fetch('/api/user.add', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(this.selectedItem),
				})
					.then(resp => resp.json()) // Transform the data into json
					.then(data => {
						
						if (data.success) {
							this.items.push(this.selectedItem);
							this.editProperty = false;
						} else {
							this.$Modal.error({
								title: 'Add Failed',
								content: data.payload
							})
						}
					})
					.catch(err => {
						this.$Modal.error({
							title: 'Error',
							content: err.toString()
						})
					})
				
			} else {

				this.selectedItem.Username_Old = this.items[this.selectedIndex].Username;

				fetch('/api/user.set', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(this.selectedItem),
				})
					.then(resp => resp.json()) // Transform the data into json
					.then(data => {
						
						if (data.success) {
							Object.assign(this.items[this.selectedIndex], this.selectedItem);
							this.editProperty = false;
						} else {
							this.$Modal.error({
								title: 'Edit Failed',
								content: data.payload
							})
						}
					})
					.catch(err => {
						this.$Modal.error({
							title: 'Error',
							content: err.toString()
						})
					})
				
			}

			
		});
	},

	showhidemodal(status) {
		if (!status) {
			setTimeout(() => {
				this.renderForm = status;
			}, 300);
		} else {
			this.renderForm = status;
		}
	},
	
    remove (index) {
	  this.selectedIndex = index;
	  this.confirmDelete = true;
	},
	
	deleteOK() {
		fetch(`/api/user.remove?Username=${encodeURIComponent(this.items[this.selectedIndex].Username)}`)
			.then(resp => resp.json()) // Transform the data into json
			.then(data => {
				// console.log(data);
				if (data.success) {
					this.items.splice(this.selectedIndex, 1);
					this.confirmDelete = false;
				} else {
					this.$Modal.error({
						title: 'Remove Failed',
						content: data.payload
					})
				}
			})
			.catch(err => {
				this.$Modal.error({
					title: 'Remove Failed',
					content: err.toString()
				})
			})
		
	},

    uploadSuccess() {
      // console.log('Upload Success');
      
      setTimeout(() => {
        this.$refs.upload.clearFiles();
        this.changePath(this.$store.state.path);
      }, 1000);
      
    },

    reload() {
      // console.log("CP " + path);

      fetch('/api/user.get')
        .then(resp => resp.json()) // Transform the data into json
        .then(data => {
          // console.log(data);
          if (data.success) {
            this.items = data.payload;
          }
        });
    }
  },

  created() {

    this.reload();
    
  },

  mounted: function () {
    
  },

  destroyed() {
    //   console.log(this.unwatch);
    
  },

  data() {
    return {
        // playlist: [],
		editProperty: false,
		addMode: true,
		selectedIndex: 0,
		selectedItem: {},
		renderForm: false,
		confirmDelete: false,
		ruleValidate: {
			Username: [
				{ required: true, message: 'The Username cannot be empty', trigger: 'blur' }
			],
			Name: [
				{ required: true, message: 'The Name cannot be empty', trigger: 'blur' }
			],
			Password: [
				{ required: false, message: 'The Password cannot be empty', trigger: 'blur' }
			],
		},
      items: [],
      columns: [
        {
          title: "Username",
          key: "Username",
		},
		{
          title: "Name",
          key: "Name",
		},
		{
          title: "Administrator",
		  key: "IsAdmin",
		  render: (h, params) => {
			  return h('input', {
				  attrs: {
					  type: 'checkbox',
					  checked: params.row.IsAdmin,
					  readonly: true
				  },
				  on: {
					  click: () => false,
					  keydown: () => false
				  }
			  })
		  }
        },

        {
          title: "Action",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.index);
                    }
                  }
                },
                "Edit"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index);
                    }
                  }
                },
                "Delete"
              )
            ]);
          }
        }
      ]
    };
  }

  // watch: {
  //     path(newPath) {
  //         console.log('>>' + newPath);
  //     }
  // }
  //   computed: {
  //     playlistx() {
  //       return this.$store.state.playlist;
  //     }
  //   }
};
</script>